import createIcon from '../../createIcon';

/**
 * @component @name Nat
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNi44MiAxM0gxMVYxMUg2LjgyQzYuNCA5Ljg0IDUuMyA5IDQgOUMyLjM0IDkgMSAxMC4zNCAxIDEyQzEgMTMuNjYgMi4zNCAxNSA0IDE1QzUuMyAxNSA2LjQgMTQuMTYgNi44MiAxM1pNNCAxM0MzLjQ1IDEzIDMgMTIuNTUgMyAxMkMzIDExLjQ1IDMuNDUgMTEgNCAxMUM0LjU1IDExIDUgMTEuNDUgNSAxMkM1IDEyLjU1IDQuNTUgMTMgNCAxM1oiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0yMyAxMkwxOSA5VjExSDE0Ljk1QzE0LjQ1IDUuOTUgMTAuMTkgMiA1IDJWNEM5LjQyIDQgMTMgNy41OCAxMyAxMkMxMyAxNi40MiA5LjQyIDIwIDUgMjBWMjJDMTAuMTkgMjIgMTQuNDUgMTguMDUgMTQuOTUgMTNIMTlWMTVMMjMgMTJaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Nat = createIcon('Nat', [
  [
    'path',
    {
      d: 'M6.82 13H11V11H6.82C6.4 9.84 5.3 9 4 9C2.34 9 1 10.34 1 12C1 13.66 2.34 15 4 15C5.3 15 6.4 14.16 6.82 13ZM4 13C3.45 13 3 12.55 3 12C3 11.45 3.45 11 4 11C4.55 11 5 11.45 5 12C5 12.55 4.55 13 4 13Z',
      key: '1ska7n',
    },
  ],
  [
    'path',
    {
      d: 'M23 12L19 9V11H14.95C14.45 5.95 10.19 2 5 2V4C9.42 4 13 7.58 13 12C13 16.42 9.42 20 5 20V22C10.19 22 14.45 18.05 14.95 13H19V15L23 12Z',
      key: '13s8aj',
    },
  ],
]);

export default Nat;
